import React, { useState } from "react";

const ContactSaisie = ({ onSubmit, field = {} }) => {
  const [formData, setFormData] = useState({
    user_name: field.user_name || "",
    user_email: field.user_email || "",
    message: field.message || "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData); // Invoke the onSubmit function with the updated form data
    
  };

  return (
    <>
<section className="contact-section py-5">
  <div className="container">
    <div className="row align-items-center justify-content-center">
     


      {/* Contact Form Section */}
      <div className="col-md-12" id="contact">
        <h2 className="text-center mb-3">Any questions?</h2>
        <p className="text-center mb-4">
          Get in touch with us today
        </p>

        <div className="col-md-12 form-container mx-auto">
            
        <form onSubmit={handleSubmit}>
              <div className="row mb-3">
                <div className="col">
                    <label htmlFor="user_name" className="form-label">
                    Full Name*
                </label>
                <input
                    type="text"
                    className="form-control"
                    id="user_name"
                    name="user_name"
                    value={formData.user_name}
                    onChange={handleChange}
                    placeholder="Your full name"
                    required
                />
                </div>
                <div className="col">
                    <label htmlFor="user_email" className="form-label">
                    Email*
                    </label>
                    <input
                        type="email"
                        className="form-control"
                        id="user_email"
                        name="user_email"
                        value={formData.user_email}
                        onChange={handleChange}
                        placeholder="Your email address"
                        required
                    />
                </div>
              </div>
              <div className="mb-3">
                <label htmlFor="message" className="form-label">
                    Your question*
                </label>
                <textarea
                    className="form-control"
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Hello, I would like to get information about ..."
                    rows="4"
                    required
                ></textarea>
              </div>
              <button type="submit" className="btn btn-submit btn-dark w-100">
                Submit
              </button>
            </form>
        </div>
      </div>
    </div>
  </div>
</section>



  </>
  );
};

export default ContactSaisie;
